module.exports = "<div class=\"cpui-antenna\"\n     [ngClass]=\"{'cpui-antenna-blurred': isBlurred}\">\n  <div class=\"cpui-antenna-nub\"></div>\n  <div class=\"cpui-antenna-shaft\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/antenna/antenna.component.html
// module id = ./src/app/components/antenna/antenna.component.html
// module chunks = main